import { Typography } from '@wishket/design-system';
import { ComponentProps } from 'react';

import { Icon } from '@/shared/Components';

const NewsletterSubscriptionButton = ({
  onClick,
}: ComponentProps<'button'>) => {
  return (
    <button
      className="box-border flex h-[52px] w-[189px] items-center justify-center gap-2 rounded-full border-2 border-primary bg-w-white shadow-graymedium hover:bg-primary-10"
      onClick={onClick}
    >
      <Icon name="fire" />
      <Typography variant="body1" className="text-w-gray-900">
        뉴스레터 구독하기
      </Typography>
    </button>
  );
};

export default NewsletterSubscriptionButton;
